// School calendar events data for Garden of Learning & Discovery Pre-K
const events = [
  // SEPTEMBER 2025
  {
    id: 1,
    title: 'Labor Day - Schools Closed',
    titleES: 'Día del trabajo - Escuela cerradas',
    date: new Date(2025, 8, 1), // September 1, 2025
    category: 'holiday',
    allDay: true,
    description: 'School closed for Labor Day.',
    descriptionES: 'La escuela está cerrada por el Día del Trabajo.'
  },
  {
    id: 2,
    title: 'No School',
    titleES: 'No Hay Clases',
    date: new Date(2025, 8, 2), // September 2, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 3,
    title: 'Back to School - First Day',
    titleES: 'Regreso a clase - Primer día',
    date: new Date(2025, 8, 4), // September 4, 2025
    category: 'academic',
    startTime: '8:30 AM',
    endTime: '11:00 AM',
    description: 'First day of school - Staggered Schedule: 8:30-11:00am Students meet the teachers',
    descriptionES: 'Primer día de clases - Horario escalonado: 8:30-11:00am Los estudiantes conocen a las maestras'
  },
  {
    id: 4,
    title: 'First Day of School - Staggered Schedule',
    titleES: 'Primer día de clases - Horario escalonado',
    date: new Date(2025, 8, 5), // September 5, 2025
    category: 'academic',
    startTime: '8:00 AM',
    endTime: '11:30 AM',
    description: 'Staggered Schedule: 8:00-11:00am Students, 11:00-11:30 Meet the teachers',
    descriptionES: 'Horario escalonado: 8:00-11:00am Estudiantes, 11:00-11:30 Conose la maestras'
  },
  {
    id: 5,
    title: 'International Literacy Day',
    titleES: 'Día Internacional de la Alfabetización',
    date: new Date(2025, 8, 8), // September 8, 2025
    category: 'academic',
    allDay: true
  },
  {
    id: 6,
    title: 'Evening Parent-Teacher Conferences',
    titleES: 'Conferencias de padres y maestros para Primaria/Preescolar',
    date: new Date(2025, 8, 17), // September 17, 2025
    category: 'pta',
    description: 'Evening Parent-Teacher Conferences for Elementary/Pre-K',
    descriptionES: 'Conferencias de padres y maestros para Primaria/Preescolar'
  },
  {
    id: 7,
    title: 'Rosh Hashanah - No School',
    titleES: 'Rosh Hashanah - No Hay Clases',
    date: new Date(2025, 8, 23), // September 23, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 8,
    title: 'Rosh Hashanah - No School',
    titleES: 'Rosh Hashanah - No Hay Clases',
    date: new Date(2025, 8, 24), // September 24, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 9,
    title: 'Walk Against Childhood Cancer',
    titleES: 'Caminata contra el cáncer infantil, Padres en el aula',
    date: new Date(2025, 8, 26), // September 26, 2025
    category: 'pta',
    startTime: '10:00 AM',
    endTime: '11:00 AM',
    description: 'Walk against childhood Cancer - Parents in the classroom',
    descriptionES: 'Caminata contra el cáncer infantil - Padres en el aula'
  },

  // OCTOBER 2025
  {
    id: 10,
    title: 'WonderSpark Puppet @ Ogden & Aurelia',
    titleES: 'Marioneta WonderSpark en Ogden y Aurela',
    date: new Date(2025, 9, 1), // October 1, 2025
    category: 'afterSchool',
    description: 'WonderSpark Puppet show at Ogden and Aurelia sites',
    descriptionES: 'Espectáculo de marionetas WonderSpark en Ogden y Aurelia'
  },
  {
    id: 11,
    title: 'Yom Kippur - School Closed',
    titleES: 'Yom Kippur - Escuela cerrada',
    date: new Date(2025, 9, 2), // October 2, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 12,
    title: 'Picture Day - Ogden, Aurelia and 3rd',
    titleES: 'Día de fotos - Ogden, Aurelia y 3rd',
    date: new Date(2025, 9, 7), // October 7, 2025
    category: 'academic',
    allDay: true
  },
  {
    id: 13,
    title: 'Latin Dance Parent Workshop @ Ogden',
    titleES: 'Taller para padres de Bailes Latinos en Ogden',
    date: new Date(2025, 9, 8), // October 8, 2025
    category: 'pta',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'Latin Dance Parent workshop at Ogden 1-2 PM',
    descriptionES: 'Taller para padres de Bailes Latinos en Ogden 1-2 p.m'
  },
  {
    id: 14,
    title: 'FitSoccer Ogden/Aurelia',
    titleES: 'Futbol en Ogden/Aurelia',
    date: new Date(2025, 9, 9), // October 9, 2025
    category: 'afterSchool',
    allDay: true
  },
  {
    id: 15,
    title: 'FitSoccer 3rd Avenue',
    titleES: 'Futbol en 3rd Avenida',
    date: new Date(2025, 9, 10), // October 10, 2025
    category: 'afterSchool',
    allDay: true
  },
  {
    id: 16,
    title: 'Indigenous Peoples\' Day - School Closed',
    titleES: 'Día de los Pueblos Indígenas - Escuela cerrada',
    date: new Date(2025, 9, 13), // October 13, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 17,
    title: 'Latin Dance @ 3rd',
    titleES: 'Baile latino en 3.rd',
    date: new Date(2025, 9, 14), // October 14, 2025
    category: 'afterSchool',
    allDay: true
  },
  {
    id: 18,
    title: 'Hispanic Heritage Month - Dress in Cultural Attire',
    titleES: 'En honor al Mes de la Herencia Hispana, por favor vengan vestidos con su vestimenta cultural',
    date: new Date(2025, 9, 15), // October 15, 2025
    category: 'academic',
    allDay: true,
    description: 'In honor of Hispanic Heritage month, please come dressed in your cultural attire.',
    descriptionES: 'En honor al Mes de la Herencia Hispana, por favor vengan vestidos con su vestimenta cultural'
  },
  {
    id: 19,
    title: 'Disability Awareness Parade',
    titleES: 'Desfile de Concienciación sobre la Discapacidad',
    date: new Date(2025, 9, 17), // October 17, 2025
    category: 'academic',
    allDay: true
  },
  {
    id: 20,
    title: 'Diwali - School Closed',
    titleES: 'Diwali - Escuela cerrada',
    date: new Date(2025, 9, 20), // October 20, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 21,
    title: 'FitSoccer Ogden/Aurelia',
    titleES: 'Futbol en Ogden/Aurelia',
    date: new Date(2025, 9, 23), // October 23, 2025
    category: 'afterSchool',
    allDay: true
  },
  {
    id: 22,
    title: 'FitSoccer 3rd Avenue',
    titleES: 'Futbol en 3ra.',
    date: new Date(2025, 9, 24), // October 24, 2025
    category: 'afterSchool',
    allDay: true
  },
  {
    id: 23,
    title: 'FitSoccer Ogden/Aurelia',
    titleES: 'Futbol en Ogden/Aurelia',
    date: new Date(2025, 9, 30), // October 30, 2025
    category: 'afterSchool',
    allDay: true
  },
  {
    id: 24,
    title: 'Dress up Character Day',
    titleES: 'Disfrazarse de día de personaje. Las familias se unen al desfile de 1-2:00 p.m.',
    date: new Date(2025, 9, 31), // October 31, 2025
    category: 'academic',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'Dress up Character Day - Families join the parade 1:00 PM - 2:00 PM',
    descriptionES: 'Disfrazarse de día de personaje. Las familias se unen al desfile de 1-2:00 p.m.'
  },

  // NOVEMBER 2025
  {
    id: 25,
    title: 'Election Day - No School',
    titleES: 'Día de elecciones - No hay classes',
    date: new Date(2025, 10, 4), // November 4, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 26,
    title: 'LEAP Parent Workshop @ Ogden',
    titleES: 'Taller para padres de LEAP en Ogden',
    date: new Date(2025, 10, 5), // November 5, 2025
    category: 'pta',
    allDay: true
  },
  {
    id: 27,
    title: 'Parent-Teacher Conferences - Early Dismissal',
    titleES: 'Reuniones entre padres y profesores - Salida anticipada de los alumnos a las 11:20 a. m.',
    date: new Date(2025, 10, 6), // November 6, 2025
    category: 'earlyDismissal',
    startTime: '11:20 AM',
    description: 'Parent-Teacher Conferences - Students Dismissed Early @ 11:20 AM',
    descriptionES: 'Reuniones entre padres y profesores - Salida anticipada de los alumnos a las 11:20 a. m.'
  },
  {
    id: 28,
    title: 'FitSoccer at 3rd',
    titleES: 'Futbol en 3ra',
    date: new Date(2025, 10, 7), // November 7, 2025
    category: 'afterSchool',
    allDay: true
  },
  {
    id: 29,
    title: 'Veteran\'s Day - No School',
    titleES: 'Día de los Veteranos - No hay classes',
    date: new Date(2025, 10, 11), // November 11, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 30,
    title: 'FitSoccer at Ogden',
    titleES: 'Futbol en Ogden/Aurelia',
    date: new Date(2025, 10, 13), // November 13, 2025
    category: 'afterSchool',
    allDay: true
  },
  {
    id: 31,
    title: 'FitSoccer at Soccer',
    titleES: 'Futbol en 3ra',
    date: new Date(2025, 10, 14), // November 14, 2025
    category: 'afterSchool',
    allDay: true
  },
  {
    id: 32,
    title: 'FitSoccer Ogden - LEAP Parent Workshop @ 3rd',
    titleES: 'Taller para padres de LEAP en 3ra',
    date: new Date(2025, 10, 20), // November 20, 2025
    category: 'afterSchool',
    allDay: true
  },
  {
    id: 33,
    title: '3rd Annual Friendsgiving',
    titleES: '3.ª edición anual de Friendsgiving, más detalles próximamente.',
    date: new Date(2025, 10, 21), // November 21, 2025
    category: 'pta',
    description: '3rd Annual Friendsgiving - More details to follow',
    descriptionES: '3.ª edición anual de Friendsgiving, más detalles próximamente.'
  },
  {
    id: 34,
    title: 'Flannel Day',
    titleES: 'Día de la franela',
    date: new Date(2025, 10, 24), // November 24, 2025
    category: 'academic',
    allDay: true
  },
  {
    id: 35,
    title: 'Wear Fall Color Days',
    titleES: 'Días para lucir los colores del otoño',
    date: new Date(2025, 10, 25), // November 25, 2025
    category: 'academic',
    allDay: true
  },
  {
    id: 36,
    title: 'Sweater Weather Day & Pumpkin Decorating Contest',
    titleES: 'Día de clima de sueter y Concurso de decoración de calabazas.',
    date: new Date(2025, 10, 26), // November 26, 2025
    category: 'academic',
    allDay: true,
    description: 'Sweater Weather Day & Pumpkin Decorating Contest',
    descriptionES: 'Día de clima de sueter y Concurso de decoración de calabazas.'
  },
  {
    id: 37,
    title: 'Thanksgiving Recess - No School',
    titleES: 'Receso por Acción de Gracias - No hay classes',
    date: new Date(2025, 10, 27), // November 27, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 38,
    title: 'Thanksgiving Recess - No School',
    titleES: 'Receso por Acción de Gracias - No hay classes',
    date: new Date(2025, 10, 28), // November 28, 2025
    category: 'holiday',
    allDay: true
  },

  // DECEMBER 2025
  {
    id: 39,
    title: 'School Spirit Family Friday: Snow Globes',
    titleES: 'Viernes familiar de espíritu escolar: Globos de nieve',
    date: new Date(2025, 11, 6), // December 6, 2025
    category: 'academic',
    allDay: true,
    description: 'School Spirit Family Friday: Snow Globes (please bring a picture of child or family)',
    descriptionES: 'Viernes familiar de espíritu escolar: Globos de nieve (traiga una foto del niño o de la familia)'
  },
  {
    id: 40,
    title: 'Parent Workshop Special Education Process',
    titleES: 'Taller para padres Proceso de educación especial',
    date: new Date(2025, 11, 12), // December 12, 2025
    category: 'pta',
    allDay: true
  },
  {
    id: 41,
    title: 'School Spirit: Winter Wonderland',
    titleES: 'Espíritu Escolar: Día del pijama',
    date: new Date(2025, 11, 18), // December 18, 2025
    category: 'academic',
    allDay: true,
    description: 'School Spirit: Winter Wonderland Wear a White Outfit like Snow! & Santa visiting Aurelia & Ogden',
    descriptionES: 'Espíritu escolar: El país de las maravillas invernal ¡Usa un traje blanco como la nieve! & Santa visitando Aurelia & Ogden'
  },
  {
    id: 42,
    title: 'Visit from Santa - 3rd Ave.',
    titleES: 'Visita de Papá Noel - 3rd Ave.',
    date: new Date(2025, 11, 19), // December 19, 2025
    category: 'academic',
    allDay: true,
    description: 'Santa visiting 3rd Avenue',
    descriptionES: 'Santa visitando 3rd Avenue'
  },
  {
    id: 43,
    title: 'Holiday Show & Student of the Month',
    titleES: 'Espectáculo navideño - Estudiante del Mes y Asistencia Perfecta',
    date: new Date(2025, 11, 20), // December 20, 2025
    category: 'academic',
    startTime: '8:30 AM',
    endTime: '11:30 AM',
    description: 'Holiday Show - Assembly Student of the Month & Perfect Attendance',
    descriptionES: 'Espectáculo navideño - Asamblea - Estudiante del Mes y Asistencia Perfecta'
  },
  {
    id: 44,
    title: 'Winter Recess Begins - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2025, 11, 23), // December 23, 2025
    category: 'holiday',
    allDay: true,
    description: 'Winter Recess begins - No School',
    descriptionES: 'Comienza el receso de invierno - No hay escuela'
  },
  {
    id: 45,
    title: 'Winter Recess - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2025, 11, 24), // December 24, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 46,
    title: 'Winter Recess - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2025, 11, 25), // December 25, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 47,
    title: 'Winter Recess - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2025, 11, 26), // December 26, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 48,
    title: 'Winter Recess - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2025, 11, 27), // December 27, 2025
    category: 'holiday',
    allDay: true
  },
  {
    id: 49,
    title: 'School Spirit: It\'s Pajama Day!',
    titleES: 'Espíritu escolar: ¡Es el día del pijama!',
    date: new Date(2025, 11, 29), // December 29, 2025
    category: 'academic',
    allDay: true,
    description: 'School Spirit: It\'s Pajama Day! Please wear your best jammies!',
    descriptionES: 'Espíritu escolar: ¡Es el día del pijama! ¡Por favor usa tus mejores pijamas!'
  },

  // JANUARY 2026
  {
    id: 50,
    title: 'Winter Recess - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2026, 0, 1), // January 1, 2026
    category: 'holiday',
    allDay: true
  },
  {
    id: 51,
    title: 'School Resumes',
    titleES: 'Regreso a la escuela',
    date: new Date(2026, 0, 2), // January 2, 2026
    category: 'academic',
    allDay: true,
    description: 'School Resumes - Back to School',
    descriptionES: 'Regreso a la escuela'
  },
  {
    id: 52,
    title: 'Kindergarten MySchools Presentation',
    titleES: 'Presentación de como aplicar en MySchools para kindergarten',
    date: new Date(2026, 0, 6), // January 6, 2026
    category: 'academic',
    startTime: '10:00 AM',
    description: 'Kindergarten MySchools Presentation at 10:00 AM',
    descriptionES: 'Presentación de como aplicar en MySchools para kindergarten 10:00 AM'
  },
  {
    id: 53,
    title: 'Mr. Mota Office Hours - Kindergarten Application',
    titleES: 'Horario de consulta con Mr. Mota en persona para el proceso de solicitud de kindergarten',
    date: new Date(2026, 0, 7), // January 7, 2026
    category: 'academic',
    description: 'Mr. Mota Office Hours (In Person) Consultation for Kindergarten Application Process',
    descriptionES: 'Horario de consulta con Mr. Mota en persona para el proceso de solicitud de kindergarten'
  },
  {
    id: 54,
    title: 'Mr. Mota Office Hours - Kindergarten Application',
    titleES: 'Horario de consulta con Mr. Mota en persona para el proceso de solicitud de kindergarten',
    date: new Date(2026, 0, 8), // January 8, 2026
    category: 'academic',
    description: 'Mr. Mota Office Hours (In Person) Consultation for Kindergarten Application Process',
    descriptionES: 'Horario de consulta con Mr. Mota (en persona) para proceso de solicitud de kindergarten'
  },
  {
    id: 55,
    title: 'Mr. Mota Office Hours - Kindergarten Application',
    titleES: 'Horario de consulta con Mr. Mota en persona para el proceso de solicitud de kindergarten',
    date: new Date(2026, 0, 9), // January 9, 2026
    category: 'academic',
    description: 'Mr. Mota Office Hours (In Person) Consultation for Kindergarten Application Process',
    descriptionES: 'Horario de consulta con Mr. Mota (en persona) para proceso de solicitud de kindergarten'
  },
  {
    id: 56,
    title: 'Virtual Turning 5 Process Presentation & Family Day',
    titleES: 'Proceso de Cumpliendo 5 Presentación Virtual 10am. Día de Familias: 1-2 pm en el aula',
    date: new Date(2026, 0, 10), // January 10, 2026
    category: 'academic',
    startTime: '10:00 AM',
    description: 'Virtual Turning 5 Process Presentation 10 AM. In Person Office Hours Consultation for Kindergarten Application Process & Turning 5 Process. Family Day: 1-2 pm in the classroom',
    descriptionES: 'Proceso de Cumpliendo 5 Presentación Virtual 10am. consulta en persona en horario de oficina para el proceso de Aplicación de Kindergarten y cumpliendo 5. Día de Familias: 1-2 pm en el salón de clase'
  },
  {
    id: 57,
    title: 'College and Career Readiness - Hat Day',
    titleES: 'Preparación para la universidad y la carrera profesional',
    date: new Date(2026, 0, 13), // January 13, 2026
    category: 'academic',
    allDay: true,
    description: 'College and Career Readiness!! Wear your favorite hat or cap.',
    descriptionES: 'Preparación para la universidad y la carrera profesional!! Nos quitamos el sombrero ante la preparación para la universidad y la carrera profesional! Ponte tu sombrero o gorra favorita.'
  },
  {
    id: 58,
    title: 'College and Career Readiness - Dress for Success',
    titleES: 'Preparación para la universidad y la carrera profesional',
    date: new Date(2026, 0, 14), // January 14, 2026
    category: 'academic',
    allDay: true,
    description: 'College and Career Readiness - Dress for success! Dress for your future career',
    descriptionES: 'Preparación para la universidad y la carrera profesional - ¡Vístete para el éxito! Vístete para tu futura carrera'
  },
  {
    id: 59,
    title: 'Pre-K Application Opens',
    titleES: 'Solicitud para nuestro Pre-K abre hoy!',
    date: new Date(2026, 0, 15), // January 15, 2026
    category: 'academic',
    allDay: true,
    description: 'Pre-K Application Opens. College and Career Readiness - Our future shines bright! Wear sunglasses and bright colors. Portraits and Self-Portraits Parent & Child Workshop in Ogden 1 to 2pm.',
    descriptionES: 'Solicitud para nuestro Pre-K abre hoy! Preparación para la universidad y la carrera profesional ¡Nuestro futuro brilla! Usa gafas de sol y colores llamativos. Taller de retratos y autorretratos para padres y hijos en Ogden de 1 to 2pm.'
  },
  {
    id: 60,
    title: 'College and Career Readiness - College Pride',
    titleES: 'Preparación para la universidad y la carrera profesional',
    date: new Date(2026, 0, 16), // January 16, 2026
    category: 'academic',
    allDay: true,
    description: 'College and Career Readiness - College Pride Day! Wear your class college colors!',
    descriptionES: 'Preparación para la universidad y la carrera profesional - ¡Día del orgullo universitario! ¡Usa los colores universitarios de tu clase!'
  },
  {
    id: 61,
    title: 'College and Career Readiness',
    titleES: 'Preparación para la universidad y la carrera profesional',
    date: new Date(2026, 0, 17), // January 17, 2026
    category: 'academic',
    allDay: true,
    description: 'College and Career Readiness - Our future Starts Here! Wear our GoLD colors!',
    descriptionES: 'Preparación para la universidad y la carrera profesional - ¡Nuestro futuro empieza aquí! ¡Usa nuestros colores ORO!'
  },
  {
    id: 62,
    title: 'MLK Jr. Day - No School',
    titleES: 'Día de MLK Jr. - Escuela Cerrada',
    date: new Date(2026, 0, 20), // January 20, 2026
    category: 'holiday',
    allDay: true
  },
  {
    id: 63,
    title: 'Portraits and Self-Portraits Parent & Child Workshop',
    titleES: 'Taller de retratos y autorretratos para padres y hijos en Third Ave 1 to 2pm.',
    date: new Date(2026, 0, 23), // January 23, 2026
    category: 'pta',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'Portraits and Self-Portraits Parent & Child Workshop in Third Ave 1 to 2pm.',
    descriptionES: 'Taller de retratos y autorretratos para padres y hijos en Third Ave 1 to 2pm.'
  },
  {
    id: 64,
    title: 'Lunar New Year - No School',
    titleES: 'Año Nuevo Lunar - Escuela Cerrada',
    date: new Date(2026, 0, 29), // January 29, 2026
    category: 'holiday',
    allDay: true
  },
  {
    id: 65,
    title: 'Virtual Assembly',
    titleES: 'Asamblea Virtual',
    date: new Date(2026, 0, 30), // January 30, 2026
    category: 'academic',
    startTime: '9:00 AM',
    description: 'Virtual Assembly at 9:00 am. Link: https://meet.google.com/nzh-zoqp-gU1',
    descriptionES: 'Asamblea Virtual a las 9:00 am. Link: https://meet.google.com/nzh-zoqp-gU1',
    link: 'https://meet.google.com/nzh-zoqp-gU1'
  },
  {
    id: 66,
    title: 'Pre-K My Schools Presentation',
    titleES: 'Presentación de cómo solicitar para nuestro Pre-K a las 10 AM!',
    date: new Date(2026, 0, 31), // January 31, 2026
    category: 'academic',
    startTime: '10:00 AM',
    description: 'Pre-K My Schools Presentation 10:00 AM (If your child is currently with us in 3k, they must still apply for a seat in with us next year for PreK).',
    descriptionES: 'Presentación de cómo solicitar para nuestro Pre-K a las 10 AM! (Si su hijo está actualmente con nosotros en 3k, aún debe solicitar un asiento para permanecer con nosotros el próximo año en PreK).'
  },

  // FEBRUARY 2026
  {
    id: 67,
    title: 'Winter Recess - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2026, 1, 1), // February 1, 2026
    category: 'holiday',
    allDay: true
  },
  {
    id: 68,
    title: 'School Resumes',
    titleES: 'Regreso a la escuela',
    date: new Date(2026, 1, 2), // February 2, 2026
    category: 'academic',
    allDay: true,
    description: 'School Resumes - Back to School',
    descriptionES: 'Regreso a la escuela'
  },
  {
    id: 69,
    title: 'Black History Celebration',
    titleES: 'Celebración de la historia Afroamericana',
    date: new Date(2026, 1, 3), // February 3, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 70,
    title: 'Black History Celebration - Lock Down Drill Practice',
    titleES: 'Celebración de la historia Afroamericana - Práctica de simulacro de bloqueo',
    date: new Date(2026, 1, 4), // February 4, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 71,
    title: 'World Read Aloud Day & LEAP Family Engagement',
    titleES: 'Día mundial de la lectura en voz alta. Compromiso familiar LEAP en Ogden Avenue de 1 a 2pm',
    date: new Date(2026, 1, 5), // February 5, 2026
    category: 'academic',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'Black History Celebration. World Read Aloud Day. LEAP Family Engagement at Ogden Avenue 1-2 pm',
    descriptionES: 'Celebración de la historia Afroamericana. Día mundial de la lectura en voz alta. Compromiso familiar LEAP en Ogden Avenue de 1 a 2pm'
  },
  {
    id: 72,
    title: 'Black History Celebration',
    titleES: 'Celebración de la historia Afroamericana',
    date: new Date(2026, 1, 6), // February 6, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 73,
    title: 'Virtual Read Aloud',
    titleES: 'Lectura virtual en voz alta',
    date: new Date(2026, 1, 7), // February 7, 2026
    category: 'academic',
    description: 'Virtual Read aloud. Link: https://meet.google.com/nzh-zoqp-gU1',
    descriptionES: 'Lectura virtual en voz alta. Link: https://meet.google.com/nzh-zoqp-gU1',
    link: 'https://meet.google.com/nzh-zoqp-gU1'
  },
  {
    id: 74,
    title: 'Respect for All Week: Celebrating Kindness',
    titleES: 'Semana del Respeto a todos: Celebrando la bondad',
    date: new Date(2026, 1, 10), // February 10, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 75,
    title: 'Respect for All Week: Anti-Bullying Awareness',
    titleES: 'Semana del Respeto a todos: Concientización contra el acoso escolar',
    date: new Date(2026, 1, 11), // February 11, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 76,
    title: 'Respect for All Week: Diversity Awareness',
    titleES: 'Semana del Respeto para todos: Conciencia de Diversidad',
    date: new Date(2026, 1, 12), // February 12, 2026
    category: 'academic',
    allDay: true,
    description: 'Respect for All Week: Diversity Awareness. *Lock Down Drill practice',
    descriptionES: 'Semana del Respeto para todos: Conciencia de Diversidad. *Práctica de simulacro de bloqueo'
  },
  {
    id: 77,
    title: 'Respect for All Week: Gender Awareness & LEAP Family Engagement',
    titleES: 'Semana del Respeto para Todos: Conciencia de Género. Compromiso familiar LEAP en 3rd Avenue de 1 a 2pm',
    date: new Date(2026, 1, 13), // February 13, 2026
    category: 'academic',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'Respect for All Week: Gender Awareness. LEAP Family Engagement at 3rd Avenue 1-2pm',
    descriptionES: 'Semana del Respeto para Todos: Conciencia de Género. Compromiso familiar LEAP en 3rd Avenue de 1 a 2pm'
  },
  {
    id: 78,
    title: 'Friendship Dance',
    titleES: 'Danza de la Amistad',
    date: new Date(2026, 1, 14), // February 14, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 79,
    title: 'Winter Break - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2026, 1, 17), // February 17, 2026
    category: 'holiday',
    allDay: true
  },
  {
    id: 80,
    title: 'Winter Break - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2026, 1, 18), // February 18, 2026
    category: 'holiday',
    allDay: true
  },
  {
    id: 81,
    title: 'Winter Break - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2026, 1, 19), // February 19, 2026
    category: 'holiday',
    allDay: true
  },
  {
    id: 82,
    title: 'Winter Break - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2026, 1, 20), // February 20, 2026
    category: 'holiday',
    allDay: true
  },
  {
    id: 83,
    title: 'Winter Break - No School',
    titleES: 'Receso de invierno - No hay escuela',
    date: new Date(2026, 1, 21), // February 21, 2026
    category: 'holiday',
    allDay: true
  },
  {
    id: 84,
    title: '100th Day of School',
    titleES: '100 Días de Escuela',
    date: new Date(2026, 1, 25), // February 25, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 85,
    title: 'Dominican Independence Day!',
    titleES: '¡Día de la Independencia Dominicana!',
    date: new Date(2026, 1, 27), // February 27, 2026
    category: 'academic',
    allDay: true,
    description: 'Dominican Independence Day! Wear Dominican colors, clothing, or cultural garb',
    descriptionES: '¡Día de la Independencia Dominicana! *Use los colores, la ropa o los atuendos culturales dominicanos'
  },
  {
    id: 86,
    title: 'Family Day / Student of the Month Award Ceremony',
    titleES: 'Día de familias / Ceremonia de los Estudiantes del mes',
    date: new Date(2026, 1, 28), // February 28, 2026
    category: 'academic',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'Family Day / Student of the Month Award Ceremony 1:00-2:00 pm',
    descriptionES: 'Día de familias / Ceremonia de los Estudiantes del mes 1:00-2:00pm'
  },

  // MARCH 2026
  {
    id: 87,
    title: 'National Social-Emotional Day',
    titleES: 'Día Nacional Socioemocional',
    date: new Date(2026, 2, 3), // March 3, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 88,
    title: 'Dr. Seuss Celebration',
    titleES: 'Celebración del Dr. Seuss',
    date: new Date(2026, 2, 4), // March 4, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 89,
    title: 'No School for Students - Virtual Parent Teacher Conference',
    titleES: 'No hay escuela para los estudiantes - Conferencia virtual de padres y maestros',
    date: new Date(2026, 2, 6), // March 6, 2026
    category: 'earlyDismissal',
    allDay: true,
    description: 'Teachers will send Google Meets link via class Dojo',
    descriptionES: 'Los maestros enviarán el enlace de Google Meets a través de Class Dojo'
  },
  {
    id: 90,
    title: 'Mardi Gras School Celebration',
    titleES: 'Celebración escolar del carnaval Mardi Gras',
    date: new Date(2026, 2, 7), // March 7, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 91,
    title: 'International Women\'s Week Celebration',
    titleES: 'Celebración de la Semana Internacional de la Mujer',
    date: new Date(2026, 2, 10), // March 10, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 92,
    title: 'International Women\'s Week Celebration',
    titleES: 'Celebración de la Semana Internacional de la Mujer',
    date: new Date(2026, 2, 11), // March 11, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 93,
    title: 'LEAP Family Engagement (Ogden Ave) Theme: Latin American Dance',
    titleES: 'Participación familiar LEAP (Ogden Ave) Tema: Danza latinoamericana',
    date: new Date(2026, 2, 12), // March 12, 2026
    category: 'pta',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'LEAP Family Engagement at Ogden Ave - Theme: Latin American Dance (1-2pm)',
    descriptionES: 'Participación familiar LEAP en Ogden Ave - Tema: Danza latinoamericana (1 a 2pm)'
  },
  {
    id: 94,
    title: 'International Women\'s Week Celebration',
    titleES: 'Celebración de la Semana Internacional de la Mujer',
    date: new Date(2026, 2, 13), // March 13, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 95,
    title: 'International Women\'s Week Celebration',
    titleES: 'Celebración de la Semana Internacional de la Mujer',
    date: new Date(2026, 2, 14), // March 14, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 96,
    title: 'Happy St. Patrick\'s Day!',
    titleES: '¡Feliz día de San Patricio!',
    date: new Date(2026, 2, 17), // March 17, 2026
    category: 'academic',
    allDay: true,
    description: 'Please wear green clothing',
    descriptionES: 'Por favor, use ropa verde.'
  },
  {
    id: 97,
    title: 'World Read Aloud Day',
    titleES: 'Día Mundial de la Lectura en Voz Alta',
    date: new Date(2026, 2, 19), // March 19, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 98,
    title: 'LEAP Family Engagement (3rd Ave) Theme: Latin American Dance',
    titleES: 'Participación familiar LEAP (3ra Ave) Tema: Danza latinoamericana',
    date: new Date(2026, 2, 20), // March 20, 2026
    category: 'pta',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'LEAP Family Engagement at 3rd Ave - Theme: Latin American Dance (1-2pm). First Day of Spring! Please wear floral',
    descriptionES: 'Participación familiar LEAP (3ra Ave) Tema: Danza latinoamericana (1 a 2pm). ¡Por favor haga que su hijo/a use ropa floral para el primer día de primavera!'
  },
  {
    id: 99,
    title: 'Ramadan Celebration',
    titleES: 'Celebración del Ramadán',
    date: new Date(2026, 2, 24), // March 24, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 100,
    title: 'Ramadan Celebration',
    titleES: 'Celebración del Ramadán',
    date: new Date(2026, 2, 25), // March 25, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 101,
    title: 'Ramadan Celebration',
    titleES: 'Celebración del Ramadán',
    date: new Date(2026, 2, 26), // March 26, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 102,
    title: 'Ramadan Celebration',
    titleES: 'Celebración del Ramadán',
    date: new Date(2026, 2, 27), // March 27, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 103,
    title: 'Family Day & Student of the Month Ceremony',
    titleES: 'Día de familias y Ceremonia de Estudiantes del mes',
    date: new Date(2026, 2, 28), // March 28, 2026
    category: 'academic',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'Family Day & Student of the Month Ceremony 1:00-2:00pm',
    descriptionES: 'Día de familias y Ceremonia de Estudiantes del mes 1:00-2:00pm'
  },
  {
    id: 104,
    title: 'Eid al-Fitr School Closed!',
    titleES: 'Eid al-Fitr - ¡No hay escuela!',
    date: new Date(2026, 2, 31), // March 31, 2026
    category: 'holiday',
    allDay: true
  },

  // APRIL 2026
  {
    id: 105,
    title: 'School Picture Day for Third Avenue!',
    titleES: '¡Día de fotografías escolares en Third Avenue!',
    date: new Date(2026, 3, 1), // April 1, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 106,
    title: 'Wear Blue for ASD / School Picture Day for Ogden & Aurelia',
    titleES: 'Vestirse de Azul para el Autismo / ¡Día de fotografías escolares en Ogden y Aurelia',
    date: new Date(2026, 3, 2), // April 2, 2026
    category: 'academic',
    allDay: true,
    description: 'Wear Blue for ASD - Autism Awareness Day',
    descriptionES: '¡Vístase de azul para el Día de Concienciación sobre el Autismo!'
  },
  {
    id: 107,
    title: 'Week of the Young Child - Music Monday',
    titleES: 'Semana del Niño Pequeño - Lunes de Música',
    date: new Date(2026, 3, 7), // April 7, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 108,
    title: 'Week of the Young Child - Tasty Tuesday',
    titleES: 'Semana del Niño Pequeño - Martes Sabroso',
    date: new Date(2026, 3, 8), // April 8, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 109,
    title: 'Week of the Young Child - Work Together Wednesday',
    titleES: 'Semana del Niño Pequeño - Miércoles de Trabajar Juntos',
    date: new Date(2026, 3, 9), // April 9, 2026
    category: 'academic',
    allDay: true,
    description: 'LEAP Family Engagement (Ogden Ave) Theme: African Dance 1-2pm',
    descriptionES: 'Participación familiar LEAP (Ogden Ave) Tema: Danza Africana (1 a 2pm.)'
  },
  {
    id: 110,
    title: 'Week of the Young Child - Artsy Thursday',
    titleES: 'Semana del Niño Pequeño - Jueves Artístico',
    date: new Date(2026, 3, 10), // April 10, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 111,
    title: 'Week of the Young Child - Family Friday',
    titleES: 'Semana del Niño Pequeño - Viernes Familiar',
    date: new Date(2026, 3, 11), // April 11, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 112,
    title: 'No School!',
    titleES: '¡No hay escuela!',
    date: new Date(2026, 3, 14), // April 14, 2026
    category: 'holiday',
    allDay: true,
    description: 'Spring Break - Enjoy Your Spring Break!',
    descriptionES: '¡Vacaciones de primavera! ¡No hay clases esta semana!'
  },
  {
    id: 113,
    title: 'No School!',
    titleES: '¡No hay escuela!',
    date: new Date(2026, 3, 15), // April 15, 2026
    category: 'holiday',
    allDay: true,
    description: 'Spring Break - Enjoy Your Spring Break!',
    descriptionES: '¡Vacaciones de primavera! ¡No hay clases esta semana!'
  },
  {
    id: 114,
    title: 'No School!',
    titleES: '¡No hay escuela!',
    date: new Date(2026, 3, 16), // April 16, 2026
    category: 'holiday',
    allDay: true,
    description: 'Spring Break - Enjoy Your Spring Break!',
    descriptionES: '¡Vacaciones de primavera! ¡No hay clases esta semana!'
  },
  {
    id: 115,
    title: 'No School!',
    titleES: '¡No hay escuela!',
    date: new Date(2026, 3, 17), // April 17, 2026
    category: 'holiday',
    allDay: true,
    description: 'Spring Break - Enjoy Your Spring Break!',
    descriptionES: '¡Vacaciones de primavera! ¡No hay clases esta semana!'
  },
  {
    id: 116,
    title: 'No School!',
    titleES: '¡No hay escuela!',
    date: new Date(2026, 3, 18), // April 18, 2026
    category: 'holiday',
    allDay: true,
    description: 'Spring Break - Enjoy Your Spring Break!',
    descriptionES: '¡Vacaciones de primavera! ¡No hay clases esta semana!'
  },
  {
    id: 117,
    title: 'LEAP Family Engagement (3rd Ave) Theme: African Dance',
    titleES: 'Participación familiar LEAP (3ra Ave) Tema: Danza Africana',
    date: new Date(2026, 3, 24), // April 24, 2026
    category: 'pta',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'LEAP Family Engagement at 3rd Ave - Theme: African Dance (1-2pm)',
    descriptionES: 'Participación familiar LEAP (3ra Ave) Tema: Danza Africana (1 a 2pm)'
  },
  {
    id: 118,
    title: 'SOTW/Parents in the classroom',
    titleES: 'SOTW/Padres en el aula',
    date: new Date(2026, 3, 25), // April 25, 2026
    category: 'pta',
    startTime: '9:00 AM',
    endTime: '10:00 AM',
    description: 'SOTW/Parents in the classroom 9:00-10:00am',
    descriptionES: 'SOTW/Padres en el aula 9:00-10:00 am'
  },

  // MAY 2026
  {
    id: 119,
    title: 'Virtual Parent Teacher Conference',
    titleES: 'Conferencia virtual de padres y maestros',
    date: new Date(2026, 4, 1), // May 1, 2026
    category: 'pta',
    description: 'Teachers will send Google Meets link via class Dojo (4:30, 5:30, 6:30pm)',
    descriptionES: 'Los maestros enviarán el enlace de Google Meets a través de Class Dojo (4:30, 5:30, 6:30pm)'
  },
  {
    id: 120,
    title: 'Cinco de Mayo Celebration!',
    titleES: '¡Celebración del Cinco de Mayo!',
    date: new Date(2026, 4, 5), // May 5, 2026
    category: 'academic',
    allDay: true,
    description: 'Wear Mexican colors, clothing, or cultural garb',
    descriptionES: 'Use los colores de ropa o los atuendos culturales mexicanos'
  },
  {
    id: 121,
    title: 'LEAP Family Engagement Ogden Ave. Theme: Zumba',
    titleES: 'Participación Familiar LEAP Ogden Ave. Tema: Zumba',
    date: new Date(2026, 4, 7), // May 7, 2026
    category: 'pta',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'LEAP Family Engagement at Ogden Ave - Theme: Zumba (1-2pm)',
    descriptionES: 'Participación Familiar LEAP Ogden Ave. Tema: Zumba 1-2pm'
  },
  {
    id: 122,
    title: 'Mother\'s Day Celebration!',
    titleES: '¡Celebración del Día de las Madres!',
    date: new Date(2026, 4, 9), // May 9, 2026
    category: 'academic',
    allDay: true,
    description: 'Wear pink colors',
    descriptionES: 'Use color de ropa rosada'
  },
  {
    id: 123,
    title: 'LEAP Family Engagement 3rd Ave. Theme: Zumba',
    titleES: 'Participación Familiar LEAP 3ra. Ave. Tema: Zumba',
    date: new Date(2026, 4, 15), // May 15, 2026
    category: 'pta',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'LEAP Family Engagement at 3rd Ave - Theme: Zumba (1-2pm)',
    descriptionES: 'Participación Familiar LEAP 3ra Ave. Tema: Zumba 1-2pm'
  },
  {
    id: 124,
    title: 'Build a Stuffed Animal - Parent Engagement for Ogden!',
    titleES: 'Construye un animal de peluche: ¡participación de los padres para Ogden Ave!',
    date: new Date(2026, 4, 19), // May 19, 2026
    category: 'pta',
    allDay: true,
    description: 'Build a Stuffed Animal - Parent Engagement for Ogden!',
    descriptionES: 'Construye un animal de peluche: ¡participación de los padres para Ogden Ave!'
  },
  {
    id: 125,
    title: 'Build a Stuffed Animal - Parent Engagement for Third Avenue!',
    titleES: 'Construye un animal de peluche: ¡participación de padres en 3ra Ave!',
    date: new Date(2026, 4, 20), // May 20, 2026
    category: 'pta',
    allDay: true,
    description: 'Build a Stuffed Animal - Parent Engagement for Third Avenue!',
    descriptionES: 'Construye un animal de peluche: ¡participación de padres en 3ra Ave!'
  },
  {
    id: 126,
    title: 'Memorial Celebration!',
    titleES: '¡Celebración Memorial!',
    date: new Date(2026, 4, 23), // May 23, 2026
    category: 'academic',
    allDay: true,
    description: 'Wear red, white, & blue colors',
    descriptionES: 'Use color de ropa rojo, blanco, y azul'
  },
  {
    id: 127,
    title: 'Memorial Day - School Closed!',
    titleES: 'Día Memorial - ¡No hay escuela!',
    date: new Date(2026, 4, 26), // May 26, 2026
    category: 'holiday',
    allDay: true
  },
  {
    id: 128,
    title: 'Family Day & Student of the Month Ceremony',
    titleES: 'Día de familias y Ceremonia de Estudiantes del mes',
    date: new Date(2026, 4, 30), // May 30, 2026
    category: 'academic',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'Family Day & Student of the Month Ceremony 1:00-2:00pm',
    descriptionES: 'Día de familias y Ceremonia de Estudiantes del mes 1:00-2:00pm'
  },

  // JUNE 2026
  {
    id: 129,
    title: 'Field Day, Aurelia!',
    titleES: '¡Día de Campo Aurelia!',
    date: new Date(2026, 5, 4), // June 4, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 130,
    title: 'School Closed!',
    titleES: '¡No hay escuela!',
    date: new Date(2026, 5, 5), // June 5, 2026
    category: 'holiday',
    allDay: true,
    description: 'Eid Mubarak',
    descriptionES: 'Eid Mubarak'
  },
  {
    id: 131,
    title: 'School Closed!',
    titleES: '¡No hay escuela!',
    date: new Date(2026, 5, 6), // June 6, 2026
    category: 'holiday',
    allDay: true,
    description: 'Clerical Day',
    descriptionES: 'Día Clerical'
  },
  {
    id: 132,
    title: 'LEAP Family Engagement Ogden Ave. Theme: Stress Management',
    titleES: 'Participación Familiar LEAP Ogden Ave. Tema: Manejo del ESTRÉS',
    date: new Date(2026, 5, 11), // June 11, 2026
    category: 'pta',
    startTime: '1:00 PM',
    endTime: '2:00 PM',
    description: 'LEAP Family Engagement at Ogden Ave - Theme: Stress Management (1-2pm)',
    descriptionES: 'Participación Familiar LEAP Ogden Ave. 1-2pm Tema: Manejo del ESTRÉS'
  },
  {
    id: 133,
    title: 'Field Day, Ogden!',
    titleES: '¡Día de Campo Ogden!',
    date: new Date(2026, 5, 12), // June 12, 2026
    category: 'academic',
    allDay: true,
    description: 'LEAP Family Engagement 3rd Ave. Theme: Stress Management (1-2pm)',
    descriptionES: 'Participación Familiar LEAP 3ra Ave. 1-2pm Tema: Manejo del ESTRÉS'
  },
  {
    id: 134,
    title: 'Field Day 3rd Ave!',
    titleES: '¡Día de Campo 3ra Ave!',
    date: new Date(2026, 5, 13), // June 13, 2026
    category: 'academic',
    allDay: true
  },
  {
    id: 135,
    title: 'School Closed!',
    titleES: '¡No hay escuela!',
    date: new Date(2026, 5, 19), // June 19, 2026
    category: 'holiday',
    allDay: true,
    description: 'Juneteenth',
    descriptionES: 'Juneteenth'
  },
  {
    id: 136,
    title: 'Carnival - Award Ceremony & Family Day!',
    titleES: '¡Ceremonia de entrega de premios Día Familiar de Carnaval!',
    date: new Date(2026, 5, 20), // June 20, 2026
    category: 'academic',
    allDay: true,
    description: 'Carnival - Award Ceremony & Family Day!',
    descriptionES: '¡Ceremonia de entrega de premios Día Familiar de Carnaval!'
  },
  {
    id: 137,
    title: 'Stepping Up in the Classroom at Aurelia!',
    titleES: '¡Dando un paso adelante en el aula en Aurelia!',
    date: new Date(2026, 5, 23), // June 23, 2026
    category: 'academic',
    allDay: true,
    description: 'Stepping Up in the Classroom at Aurelia!',
    descriptionES: '¡Dando un paso adelante en el aula en Aurelia!'
  },
  {
    id: 138,
    title: 'Ogden Ave Stepping Up in the Classroom',
    titleES: 'Ceremonia de graduación 4k de Ogden Ave 3k - Un paso adelante en el aula',
    date: new Date(2026, 5, 24), // June 24, 2026
    category: 'academic',
    allDay: true,
    description: 'Ogden Ave Stepping Up in the Classroom',
    descriptionES: 'Ceremonia de graduación 4k de Ogden Ave 3k - Un paso adelante en el aula'
  },
  {
    id: 139,
    title: '3rd Ave Stepping Up in the Classroom',
    titleES: 'Ceremonia de graduación 4k de 3rd Ave 3k - Un paso adelante en el aula',
    date: new Date(2026, 5, 25), // June 25, 2026
    category: 'academic',
    allDay: true,
    description: '3rd Ave Stepping Up in the Classroom',
    descriptionES: 'Ceremonia de graduación 4k de 3rd Ave 3k - Un paso adelante en el aula'
  },
  {
    id: 140,
    title: 'Last Day of School!',
    titleES: '¡Último Día Escolar!',
    date: new Date(2026, 5, 26), // June 26, 2026
    category: 'academic',
    allDay: true,
    description: 'Last Day of School! Have a Great Summer!',
    descriptionES: '¡Último Día Escolar! ¡Que tengas un gran verano!'
  }
];

export default events;
